import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { parseApiResponseError } from '../../../../api/api-error';
import apiManager from '../../../../api/api-manager';
import { DettagliErrore } from '../../../../api/generated/apc/api';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { UnlockUserError, UnlockUserState } from './unlock-user-types';
import { verifyUnlockUserFields } from './unlock-user-utils';

const initialState: UnlockUserState = {
  unlockUserRequestStatus: 'idle',
};

export const unlockUser = createAsyncThunk<
  string,
  void,
  AsyncThunkConfig<UnlockUserError>
>('unlockUser', async (_, thunkApi) => {
  try {
    const userState = thunkApi.getState().data.user;
    const validationError = verifyUnlockUserFields(userState.username);
    if (validationError) {
      return thunkApi.rejectWithValue(validationError);
    }

    await apiManager.loginApi.inizializzazioneSbloccoUtenza(userState.username);

    return null;
  } catch (error) {
    const apiError = parseApiResponseError<DettagliErrore>(error);
    const invalidFields = apiError.payload?.campiNonValidi;

    if (invalidFields && invalidFields?.length > 0) {
      return thunkApi.rejectWithValue('INVALID_CREDENTIALS');
    } else {
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }
  }
});

const unlockUserSlice = createSlice({
  name: 'features/unlockUser',
  initialState,
  reducers: {
    resetUnlockUserState(state) {
      state.unlockUserError = undefined;
      state.unlockUserRequestStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unlockUser.pending, (state) => {
      state.unlockUserRequestStatus = 'loading';
    });
    builder.addCase(unlockUser.fulfilled, (state) => {
      state.unlockUserRequestStatus = 'succeeded';
    });
    builder.addCase(unlockUser.rejected, (state, action) => {
      state.unlockUserError = action.payload || 'GENERIC_ERROR';
      state.unlockUserRequestStatus = 'failed';
    });
  },
});

export const { resetUnlockUserState } = unlockUserSlice.actions;

export default unlockUserSlice.reducer;
